import { render, staticRenderFns } from "./add_person.vue?vue&type=template&id=1b232466&scoped=true"
import script from "./add_person.vue?vue&type=script&lang=js"
export * from "./add_person.vue?vue&type=script&lang=js"
import style0 from "./add_person.vue?vue&type=style&index=0&id=1b232466&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b232466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b232466')) {
      api.createRecord('1b232466', component.options)
    } else {
      api.reload('1b232466', component.options)
    }
    module.hot.accept("./add_person.vue?vue&type=template&id=1b232466&scoped=true", function () {
      api.rerender('1b232466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/task/form/add_person.vue"
export default component.exports